import { Collapse, Empty, Flex, Modal, Rate } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { formatDateOnly, formatDayMonth } from "../../utils/date";
import Icon from "../../Component/SideNavIcon";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import "react18-json-view/src/dark.css";

const StyledDateContainer = styled.div`
  width: auto;
  padding: 10px;
  height: 100%;
  min-height: 50px;
  background-color: #e1e2eb;
  border-radius: 8px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: -1px 1px 8px rgba(128, 128, 128, 0.2);
  border: 1px solid #625977;
`;

const StyledTimeContainer = styled.div`
  width: 100px;
  height: auto;
  padding: 10px;
  font-size: 13px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: -1px 1px 8px rgba(128, 128, 128, 0.2);
  border: 1px solid #ccc;
`;

const StyledTag = styled.div`
  padding: 5px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 10px;
  box-shadow: -1px 1px 8px rgba(128, 128, 128, 0.2);
  border: 1px solid #625977;
  margin-bottom: 10px;
  cursor: pointer;
  max-height: 35px;
`;

const StyledItemContainer = styled.div`
  background-color: #e1e2eb;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 10px;
  font-size: 13px;
  width: 100%;
  .details {
    color: green;
    font-size: 11px;
  }
  span {
    font-weight: 600;
  }
  .sub_title{
    color:black;
    font-weight: normal;
  }
  
  .suggestion-grid {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
  }

  .suggestion-column {
    flex: 1;
    background: #f9f9f9;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0 0 5px rgba(0,0,0,0.1);
    width: 50px;
  }

  .suggestion-column ul {
    list-style-type: disc;
    
  }

  .custom-dot {
    list-style: none;
    position: relative;
    padding-left: 1.2em;
  }

  .custom-dot::before {
    content: '•';
    color: rgb(51, 51, 51);
    position: absolute;
    left: 0;
  }


`;

const StyledFlex = styled(Flex)`
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  .active {
    background-color: #e1e2eb;

    border: 2px solid #625977;
  }
  .active_json {
    background-color: #e1e2eb;
    border: 2px solid #625977;
  }
  .title {
    font-weight: 600;
    font-size: 13px;
  }
`;

const StyledTourCard = styled.div`
  display: flex;
  gap: 12px;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;

  .tour-image {
    width: 120px;
    height: 100px;
    object-fit: cover;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .tour-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .tour-title {
    font-weight: 600;
    font-size: 13px;
    color: #333;
    margin: 0;
  }

  .tour-description {
    font-size: 11px;
    color: #666;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .tour-reviews {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
  }

  .tour-rating {
    color: #f5a623;
    font-weight: 600;
  }

  .tour-count {
    color: #888;
  }

  .tour-price {
    font-size: 12px;
    color: #555;
    margin: 0;
  }

  .tour-link {
    font-size: 12px;
    color: #1a73e8;
    text-decoration: none;
    font-weight: 500;
    margin-top: auto;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ScrollContainer = styled.div`
  max-height: calc(85vh - 100px);
  overflow-y: auto;
`;

const TitleContainer = ({ date, content, weather }) => (
  <Flex gap="large">
    {date && <StyledDateContainer>{formatDayMonth(date)}</StyledDateContainer>}
    {/* className={weather ? "" : "mt-4"} */}
    <p className="mt-4">{content} 
      {/* {weather && (
          <>
            {" "}
            <br></br>
            <strong>Weather:</strong> {weather}
          </>
        )} */}
      </p>
    
  </Flex>
);

const timeAgo = (dateStr) => {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days} day${days !== 1 ? "s" : ""} ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
  const years = Math.floor(months / 12);
  return `${years} year${years !== 1 ? "s" : ""} ago`;
};

const ReviewModal = ({ visible, onClose, reviewData }) => {
  if (!reviewData) return null;
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={reviewData.place_name || reviewData.name}
      width={720}
    >
      <div style={{ marginBottom: "0.8rem", display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{ fontSize: "16px", fontWeight: "700" }}>{reviewData.rating}</span>
        <Rate disabled allowHalf value={reviewData.rating} style={{ fontSize: "14px" }} />
      </div>

      {reviewData.images?.length > 0 && (
        <div
          style={{
            display: "flex",
            gap: "8px",
            overflowX: "auto",
            marginBottom: "1rem",
            paddingBottom: "4px",
          }}
        >
          {reviewData.images.map((img, idx) => (
            <img
              key={idx}
              src={`${process.env.REACT_APP_API_BASE_URL}${img}`}
              alt={`${reviewData.place_name} ${idx + 1}`}
              style={{
                width: "130px",
                height: "95px",
                objectFit: "cover",
                borderRadius: "8px",
                flexShrink: 0,
              }}
            />
          ))}
        </div>
      )}

      {reviewData.map_link && (
        <div style={{ marginBottom: "1rem" }}>
          <a href={reviewData.map_link} target="_blank" rel="noopener noreferrer">
            View on Google Maps
          </a>
        </div>
      )}

      <div style={{ maxHeight: "320px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px" }}>
        {reviewData.reviews?.map((review, idx) => (
          <div
            key={idx}
            style={{
              padding: "10px",
              background: "#f5f5f5",
              borderRadius: "8px",
              fontSize: "12px",
              color: "#333",
              lineHeight: "1.6",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
              <span style={{ fontWeight: "600", color: "#444" }}>
                {review.authorAttribution?.displayName || "Anonymous"}
              </span>
              <span style={{ color: "#999", fontSize: "11px" }}>
                {timeAgo(review.publishTime)}
              </span>
            </div>
            {review.text?.text}
          </div>
        ))}
        {(!reviewData.reviews || reviewData.reviews.length === 0) && (
          <p style={{ color: "#999", fontSize: "12px" }}>No reviews available.</p>
        )}
      </div>
    </Modal>
  );
};

const ListItems = ({ acts }) => {
  const [reviewModal, setReviewModal] = useState({ visible: false, data: null });
  return (
    <>
      <ReviewModal
        visible={reviewModal.visible}
        onClose={() => setReviewModal({ visible: false, data: null })}
        reviewData={reviewModal.data}
      />
  <div className="pl-8">
    {acts?.map((act, index) => (
      <Flex gap="small" key={index} style={{ marginBottom: "10px" }}>
        <StyledTimeContainer>
          {act?.tm || act?.time || String(index + 1)}
        </StyledTimeContainer>
        <StyledItemContainer>
          {/* {Object.entries(act).map(([key, value]) =>
            key !== "tm" ? <p key={key}>{`${key}: ${value}`}</p> : null
          )} */}
          {act?.type === "sports_venue" ? (
            <span>Sports Venue</span>
          ) : act?.type === "sport_merchandise_or_other" ? (
            <span>Sports Merchandise</span>
          ) : act?.type === "sport_activities" ? (
            <span>{act?.sub_type}</span>
          ) : (
            <span>{act?.desc}</span>
          )}

          {act?.type === "move" && (
            <>
              <p className="details">
                <span className="sub_title">Transport :</span> {act?.move_type} {act?.move_no}
              </p>
              {(act?.move_duration || act?.duration) && (
                <p className="details"><span className="sub_title">Durations :</span> {act?.move_duration || act?.duration}</p>
              )}
              <p className="details"><span className="sub_title">Approx cost :</span> {act?.cost}</p>
            </>
          )}
          {act?.type === "stay" && (
            <>
              {!act?.check_in_suggestions ? (
                <>
                  <p className="details">
                    <span className="sub_title">Hotel Name :</span> {act?.stay_name || act?.name}
                  </p>
                  <p className="details">
                    <span className="sub_title">Check-in Date :</span>{" "}
                    {formatDateOnly(
                      act?.check_in_datetime || act?.checkin_datetime
                    )}
                  </p>
                  <p className="details">
                    <span className="sub_title">Check-out Date :</span>{" "}
                    {formatDateOnly(
                      act?.check_out_datetime || act?.checkout_datetime
                    )}
                  </p>
                  <p className="details"><span className="sub_title">Address :</span> {act?.stay_addr || act?.addr}</p>
                  <p className="details"><span className="sub_title">Approx cost :</span> {act?.cost}</p>
                </>
              ) : (
                <>
                  <h4 style={{ fontWeight: "650" }}>Check in suggestions</h4>
                  <div className="suggestion-grid" >
                    
                  {act?.check_in_suggestions?.map((option, index) => (
                    <div className="suggestion-column" key={index}>
                      <h4 style={{ fontWeight: "bold" }}>Option {index + 1}</h4>
                      <ul className="details">
                        <li className="custom-dot"><span className="sub_title">Hotel :</span> {option.stay_name}</li>
                        <li className="custom-dot"><span className="sub_title">Address :</span> {option.stay_addr}</li>
                        <li className="custom-dot"><span className="sub_title">Cost :</span> {option.cost}</li>
                        <li className="custom-dot"><span className="sub_title">Check-in :</span> {option.check_in_time}</li>
                        <li className="custom-dot">
                          <span className="sub_title">Check-out : </span>
                          {formatDateOnly(option.check_out_datetime)}
                        </li>
                        {/* <li className="custom-dot">
                          <span className="sub_title">Booking Link : </span>
                          <a href={option.booking_link.link} target="_blank" rel="noreferrer">
                            {option.booking_link.title}
                          </a>
                        </li> */}
                        <li className="custom-dot"><span className="sub_title">Description :</span> {option.desc}</li>
                        {option.review_data?.is_success && (
                          <>
                            <li className="custom-dot"><span className="sub_title">Agoda Booking Url :</span> {option.review_data.agoda_booking_url}</li>
                            <li className="custom-dot"><span className="sub_title">Agoda Landing Url :</span> {option.review_data.agoda_landing_url ? option.review_data.agoda_landing_url : "-"}</li>
                            <li
                              className="custom-dot"
                              style={{ cursor: "pointer", color: "#625977", fontWeight: "600" }}
                              onClick={() => setReviewModal({ visible: true, data: option.review_data })}
                            >
                              View Reviews
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  ))}
                </div>

                </>
              )}
            </>
          )}
          {act?.type === "do" && (
            <>
              <p className="details"><span className="sub_title">Visit :</span> {act?.place || act?.name}</p>
              {act?.addr && (<p className="details"><span className="sub_title">Address :</span> {act?.addr}</p>) }
              <p className="details"><span className="sub_title">Approx cost :</span> {act?.cost}</p>

              {/* other tips */}
              {act?.other_tips && act?.nearby_amenities && (
                <>
                  <div className="suggestion-grid" >
                    <div className="suggestion-column" >
                      <h4 style={{ fontWeight: "bold" }}>Description</h4>
                      <ul className="details">
                        <li className="custom-dot">{act?.desc}</li>
                      </ul>
                    </div>
                    <div className="suggestion-column" >
                      <h4 style={{ fontWeight: "bold" }}>Nearby Amenities</h4>
                      {act?.nearby_amenities?.map((option, index) => (
                        <ul className="details" key={index}>
                          <li className="custom-dot">{option}</li>
                        </ul>
                      ))}
                    </div>
                    <div className="suggestion-column" >
                      <h4 style={{ fontWeight: "bold" }}>Other Tips</h4>
                      
                      <ul className="details" >
                        <li className="custom-dot"><span className="sub_title">Local Tip :</span> {act?.other_tips?.local_tip}</li>
                        <li className="custom-dot"><span className="sub_title">Best Time :</span> {act?.other_tips?.best_time_to_visit}</li>
                        {/* <li className="custom-dot"><span className="sub_title">Audio Link :</span> <a href={act?.other_tips?.audio_link?.link} target="_blank" rel="noreferrer">{act?.other_tips?.audio_link?.title} </a></li> */}
                        {act?.other_tips?.other_link?.link && ( 
                          <li className="custom-dot"><span className="sub_title">Other Link :</span> <a href={act?.other_tips?.other_link?.link} target="_blank" rel="noreferrer">{act?.other_tips?.other_link?.title} </a></li>
                        )}
                      </ul>
                      
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          {act?.type === "eat" && (
            <>
              <p className="details"><span className="sub_title">Dining :</span> {act?.eat_name || act?.name}</p>
              <p className="details"><span className="sub_title">Address :</span> {act?.eat_addr || act?.addr}</p>
              <p className="details"><span className="sub_title">Approx cost :</span> {act?.cost}</p>
            </>
          )}
          {act?.type === "relax_at_hotel_or_explore" && (
            <>
              <p className="details"><span className="sub_title">Name :</span> {act?.name}</p>
              <p className="details"><span className="sub_title">Address :</span> {act?.addr}</p>
              <p className="details"><span className="sub_title">Description :</span> {act?.desc}</p>
            </>
          )}
          {act?.type === "other_sightseeing" && (
            <>
              <p className="details">Name : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}
          {act?.type === "local_sightseeing" && (
            <>
              <p className="details">Visit : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}
          {act?.type === "meetings" && (
            <>
              <p className="details">Visit : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
            </>
          )}
          {act?.type === "team_outing" && (
            <>
              <p className="details">Visit : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}

          {act?.type === "work_activities" && (
            <>
              <p className="details">Visit : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}
          {act?.type === "sports_venue" && (
            <>
              <p className="details">{act?.desc}</p>
              <p className="details">Match : {act?.match_team}</p>
              {act?.name && <p className="details">Venue : {act?.name}</p>}
              {act?.tournament_name && (
                <p className="details">Tournament : {act?.tournament_name}</p>
              )}
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}
          {act?.type === "sport_merchandise_or_other" && (
            <>
              <p className="details">Name : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}
          {act?.type === "sport_activities" && (
            <>
              <p className="details">{act?.desc}</p>
              <p className="details">Visit : {act?.name}</p>
              <p className="details">Address : {act?.addr}</p>
              <p className="details">Approx cost : {act?.cost}</p>
            </>
          )}
        </StyledItemContainer>
      </Flex>
    ))}
  </div>
    </>
  );
};

const ContainerStyle = {
  borderRadius: "20px",
  boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
  border: "1px solid #ccc",
  padding: "30px",
};

const DISPLAY_FIELDS_BY_CATEGORY = {
  transportation: {
    title: "name",
    transport_number: "Transport Number",
    name: "Name",
    start_time: "Start at",
    end_loc: "Arrival In",
    end_time: "Arrival at",
    type: "Mode of transport",
    duration: "Travel Duration",
    budget: "Cost",
  },
  food_dining: {
    title: "name",
    est_budget: "Cost (Approx)",
    rating: "Rating",
    open_time: "Open Time",
    close_time: "Close Time",
    address: "Address",
    description: "",
  },
  accommodation: {
    title: "name",
    addr: "Address",
    desc: "Description",
    cost: "Approx cost",
    // insider_tips: "Insider Tips",
    // traveler_rating_review: "Traveler Rating Review",
    // booking_deals: "Booking Deals",
    amenities_around: "Amenities Around",
    transport_access: "Transport Access",
    nearby_attractions: "Nearby Attractions",
  },
};

const CommonListItems = ({ acts, category_slug, activeCustomTab }) => {
  const [reviewModal, setReviewModal] = useState({ visible: false, data: null });
  const displayConfig = DISPLAY_FIELDS_BY_CATEGORY[category_slug] || {};
  if (category_slug === "essentials") {
    return (
      <div className="pl-5" style={ContainerStyle}>
        {acts?.package && activeCustomTab === "package" && (
          <>
            <p className="mb-3">Packages </p>
            {acts?.package?.map((act, index) => (
              <Flex gap="small" key={index} style={{ marginBottom: "10px" }}>
                <StyledTimeContainer>
                  {act?.start_time ? (
                    <>{formatDayMonth(act?.start_time)}</>
                  ) : (
                    <>{index + 1}</>
                  )}
                </StyledTimeContainer>
                <StyledItemContainer>
                  <span>{act?.category_type}</span>
                  <>
                    {act?.items && (
                      <>
                        {act?.items?.map((item, index) => (
                          <p key={index} className="details">
                            {item}
                          </p>
                        ))}
                      </>
                    )}
                  </>
                </StyledItemContainer>
              </Flex>
            ))}
          </>
        )}
        {acts?.documents && activeCustomTab === "documents" && (
          <>
            <p className="mb-3">Documents</p>
            {acts?.documents?.map((act, index) => (
              <Flex gap="small" key={index} style={{ marginBottom: "10px" }}>
                <StyledTimeContainer>
                  {act?.start_time ? (
                    <>{formatDayMonth(act?.start_time)}</>
                  ) : (
                    <>{index + 1}</>
                  )}
                </StyledTimeContainer>
                <StyledItemContainer>
                  <span>{act?.document_name}</span>

                  <p className="details">{act?.desc}</p>
                </StyledItemContainer>
              </Flex>
            ))}
          </>
        )}
      </div>
    );
  }

  return (
    <div className="pl-5" style={ContainerStyle}>
      <ReviewModal
        visible={reviewModal.visible}
        onClose={() => setReviewModal({ visible: false, data: null })}
        reviewData={reviewModal.data}
      />
      {/* {activeCustomTab === "tour_guide" && acts?.map((act, index) => (
        <div key={index} style={{ marginBottom: "8px" }}>
          <StyledTourCard>
            {act?.image && (
              <img
                src={act.image}
                alt={act.title || act.name}
                className="tour-image"
              />
            )}
            <div className="tour-info">
              <p className="tour-title">{act?.title || act?.name}</p>
              {act?.description && (
                <p className="tour-description">{act.description}</p>
              )}
              {act?.reviews && (
                <div className="tour-reviews">
                  <span className="tour-rating">
                    ★ {act.reviews.combinedAverageRating?.toFixed(1)}
                  </span>
                  <span className="tour-count">
                    ({act.reviews.totalReviews})
                  </span>
                </div>
              )}
              {act?.productUrl && (
                <a
                  href={act.productUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tour-link"
                >
                  Check Availability ↗
                </a>
              )}
            </div>
          </StyledTourCard>
        </div>
      ))} */}
      {activeCustomTab !== "tour_guide" && acts?.map((act, index) => {
        const titleKey = displayConfig?.title; // e.g., 'desc'
        const titleValue = act?.[titleKey]; // e.g., act['desc']

        return (
          <Flex gap="small" key={index} style={{ marginBottom: "10px" }}>
            <StyledTimeContainer>
              {act?.start_time && category_slug !== "transportation" ? (
                <>{formatDayMonth(act?.start_time)}</>
              ) : (
                <>{index + 1}</>
              )}
            </StyledTimeContainer>
            <StyledItemContainer>
              { }
              {titleValue && <p>{titleValue}</p>}

              {(() => {
                const groupedKeys = ["amenities_around", "nearby_attractions", "transport_access"];
                const hasGroupedData = category_slug === "accommodation" &&
                  groupedKeys.some(key => Array.isArray(act[key]));

                return (
                  <>
                    
                    {/* Render all other fields except the grouped ones */}
                    {Object.keys(displayConfig).map((key) => {
                      if (key === titleKey || !(key in act)) return null;
                      if (groupedKeys.includes(key)) return null; // Skip grouped keys here

                      const value = act[key];
                      const label = displayConfig[key];

                      if (category_slug === "accommodation") {
                        if (key === "title" || key === "addr" || key === "desc" || key === "cost") {
                          return (
                            <div className="details" key={key} style={{ marginBottom: "0.2rem" }}>
                              <p>
                                <span className="sub_title">{label} {label ? " : " : ""}</span> {value}
                              </p>
                            </div>
                          );
                        }

                        if (key === "traveler_rating_review" && typeof value === "object") {
                          return (
                            <div className="details" key={key} style={{ marginBottom: "0.7rem" }}>
                              <p><span className="sub_title">Traveler Rating :</span> {value.rating}</p>
                              <p>"{value.review}"</p>
                            </div>
                          );
                        }

                        if (key === "booking_deals" && Array.isArray(value)) {
                          return (
                            <div className="details" key={key} style={{ marginBottom: "0.7rem" }}>
                              <p className="sub_title">Booking Deals :</p>
                              {value.map((deal, idx) => (
                                <p key={idx} className="ml-4" style={{ position: "relative", paddingLeft: "1rem" }}>
                                  <a href={deal.link} target="_blank" rel="noopener noreferrer">
                                    <span
                                      style={{
                                        position: "absolute",
                                        left: 0,
                                        color: "#333",
                                      }}
                                    >
                                      •
                                    </span> {deal.title}
                                  </a>
                                </p>
                              ))}
                            </div>
                          );
                        }

                        if (key === "insider_tips" && Array.isArray(value)) {
                          return (
                            <div className="details" key={key} style={{ marginBottom: "0.7rem" }}>
                              <p className="sub_title">{label} :</p>
                              <div style={{ paddingLeft: "1rem" }}>
                                {value.map((item, idx) => (
                                  <div key={idx} style={{ position: "relative", paddingLeft: "1rem" }}>
                                    <span
                                      style={{
                                        position: "absolute",
                                        left: 0,
                                        color: "#333",
                                      }}
                                    >
                                      •
                                    </span>
                                    {item}
                                  </div>
                                ))}
                              </div>
                            </div>
                          );
                        }

                      }

                      // Default render
                      return (
                        <div className="details" key={key}>
                          {Array.isArray(value) ? (
                            <>
                              <p className="sub_title">
                                {label} {label ? " : " : ""}
                              </p>
                              {value.map((item, idx) => (
                                <p key={idx} className="ml-4">{item}</p>
                              ))}
                            </>
                          ) : (
                            <p>
                              <span className="sub_title">{label} {label ? " : " : ""}</span> {value}
                            </p>
                          )}
                        </div>
                      );
                    })}

                    {/* View Reviews button for accommodation */}
                    {category_slug === "accommodation" && act?.review_data?.is_success && (
                      <div style={{ marginTop: "0.4rem" }}>
                        <div className="details">
                          <span className="sub_title">Agoda Booking Url:</span> { act?.review_data?.agoda_booking_url ? act?.review_data?.agoda_booking_url : "-" }
                        </div>
                        <div className="details">
                          <span className="sub_title">Agoda Landing Url:</span> { act?.review_data?.agoda_landing_url ? act?.review_data?.agoda_landing_url : "-" }
                        </div>
                        <span
                          style={{ cursor: "pointer", color: "#625977", fontWeight: "600", fontSize: "12px" }}
                          onClick={() => setReviewModal({ visible: true, data: act.review_data })}
                        >
                          View Reviews
                        </span>
                      </div>
                      
                      
                      
                    )}

                    {/* Special 3-column grid for amenities/attractions/transport */}
                    {hasGroupedData && (
                      <div className="details" key="grouped-columns" style={{ marginBottom: "1rem" }}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: "1rem",
                            paddingLeft: "0.5rem",
                          }}
                        >
                          {groupedKeys.map((key) => (
                            <div key={key}>
                              <p className="sub_title">{displayConfig[key]}</p>
                              {Array.isArray(act[key]) && act[key].length > 0 ? (
                                act[key].map((item, idx) => (
                                  <p key={idx} style={{ position: "relative", paddingLeft: "1rem" }}>
                                    <span
                                      style={{
                                        position: "absolute",
                                        left: 0,
                                        color: "#333",
                                      }}
                                    >
                                      •
                                    </span>
                                    {item}
                                  </p>
                                ))
                              ) : (
                                <p style={{ fontStyle: "italic", color: "#777" }}>N/A</p>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                );
              })()}


              {activeCustomTab === "ignored_user_preference" && (
                <>
                  <span>
                    {act?.preference_type
                      .replace(/_/g, " ") // Replace underscores with spaces
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </span>
                  <div className="details">
                    <p>{act?.preference}</p>
                    <p>Reason : {act?.reason}</p>
                  </div>
                </>
              )}

              {activeCustomTab === "tournament_booking_assistance" && (
                <>
                  <span>{act?.type}</span>
                  <div className="details">
                    <p>{act?.desc}</p>
                    {act?.addr && <p>Address : {act?.addr}</p>}
                    {act?.url && <p>Site : {act?.url}</p>}
                  </div>
                </>
              )}
              {activeCustomTab === "tips" && (
                <>
                  <span>{act?.tip_type}</span>
                  <div className="details">
                    <p>{act?.desc}</p>
                    <p>
                      {act?.tips?.map((item, idx) => (
                        <p key={idx}>{item}</p>
                      ))}
                    </p>
                  </div>
                </>
              )}

              {/* accommodation - tour guide */}
              {activeCustomTab === "tour_guide" && (
                <>
                {act?.tour_guide && act.tour_guide.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <p className="sub_title" style={{ fontWeight: "600", marginBottom: "0.4rem" }}>Tour Guide</p>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      {act.tour_guide.map((tour, idx) => (
                        <StyledTourCard key={idx}>
                          {tour?.image && (
                            <img
                              src={tour.image}
                              alt={tour.title}
                              className="tour-image"
                            />
                          )}
                          <div className="tour-info">
                            <p className="tour-title">{tour?.title}</p>
                            {tour?.description && (
                              <p className="tour-description">{tour.description}</p>
                            )}
                            {tour?.reviews && (
                              <div className="tour-reviews">
                                <span className="tour-rating">
                                  ★ {tour.reviews.combinedAverageRating?.toFixed(1)}
                                </span>
                                <span className="tour-count">
                                  ({tour.reviews.totalReviews})
                                </span>
                              </div>
                            )}
                            {tour?.productUrl && (
                              <a
                                href={tour.productUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="tour-link"
                              >
                                Check Availability ↗
                              </a>
                            )}
                          </div>
                        </StyledTourCard>
                      ))}
                    </div>
                  </div>
                )}
                </>
              )}
            </StyledItemContainer>
          </Flex>
        );
      })}
      {acts?.length === 0 && <Empty />}
    </div>
  );
};

const BestTimeListItems = ({ data, activeTab }) => {
  return (
    <div className="pl-5">
      {data?.map((act, index) => {
        return (
          <Flex gap="small" key={index} style={{ marginBottom: "10px" }}>
            {activeTab !== "tour_guide" && (
              <StyledTimeContainer>
                {activeTab === "best_month_to_visit" ||
                  activeTab === "month_to_avoid" ? (
                  <>{act?.months}</>
                ) : (
                  <>
                    {act?.start_time ? (
                      <>{formatDayMonth(act?.start_time)}</>
                    ) : (
                      <>{index + 1}</>
                    )}
                  </>
                )}
              </StyledTimeContainer>
            )}
            {(activeTab === "best_month_to_visit" ||
              activeTab === "month_to_avoid") && (
                <StyledItemContainer>
                  <span>Season : {act?.season}</span>
                  <div className="details">
                    {act?.reason?.map((item, idx) => (
                      <p key={idx}>{item}</p>
                    ))}
                  </div>
                </StyledItemContainer>
              )}
            {activeTab === "tournament_booking_assistance" && (
              <StyledItemContainer>
                <span>{act?.type}</span>
                <div className="details">
                  <p>{act?.desc}</p>
                  {act?.addr && <p>Address : {act?.addr}</p>}
                  {act?.url && <p>Site : {act?.url}</p>}
                </div>
              </StyledItemContainer>
            )}
            {activeTab === "tips" && (
              <StyledItemContainer>
                <span>{act?.tip_type}</span>
                <div className="details">
                  <p>{act?.desc}</p>
                  <p>
                    {act?.tips?.map((item, idx) => (
                      <p key={idx}>{item}</p>
                    ))}
                  </p>
                </div>
              </StyledItemContainer>
            )}

            {activeTab === "ignored_user_preference" && (
              <StyledItemContainer>
                <span>
                  {act?.preference_type
                    .replace(/_/g, " ") // Replace underscores with spaces
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                </span>
                <div className="details">
                  <p>{act?.preference}</p>
                  <p>Reason : {act?.reason}</p>
                </div>
              </StyledItemContainer>
            )}

            {activeTab === "tour_guide" && (
              <StyledTourCard>
                {act?.image && (
                  <img
                    src={act.image}
                    alt={act.title || act.name}
                    className="tour-image"
                  />
                )}
                <div className="tour-info">
                  <p className="tour-title">{act?.title || act?.name}</p>
                  {act?.description && (
                    <p className="tour-description">{act.description}</p>
                  )}
                  {act?.reviews && (
                    <div className="tour-reviews">
                      <span className="tour-rating">
                        ★ {act.reviews.combinedAverageRating?.toFixed(1)}
                      </span>
                      <span className="tour-count">
                        ({act.reviews.totalReviews})
                      </span>
                    </div>
                  )}
                  {act?.productUrl && (
                    <a
                      href={act.productUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="tour-link"
                    >
                      Check Availability ↗
                    </a>
                  )}
                </div>
              </StyledTourCard>
            )}

            {activeTab === "others" && (
              <StyledItemContainer>
                <div className="details">
                  <p className="sub_title">{act?.title}</p>
                  {act?.tips?.map((tip, idx) => (
                    <p
                      key={idx}
                      style={{
                        position: "relative",
                        paddingLeft: "1rem",
                      }}
                    >
                      <span
                        style={{
                          position: "absolute",
                          left: 0,
                          color: "#333",
                        }}
                      >
                        •
                      </span>
                      {tip}
                    </p>
                  ))}

                </div>
              </StyledItemContainer>
            )}
          </Flex>
        );
      })}

      {data?.length === 0 && <Empty />}
    </div>
  );
};

function ListView({
  data,
  isPlan,
  category_slug,
  essentialData,
  jsonStructure,
  category_name,
  renderKey,
  initialValues,
}) {
  const tagList = [
    {
      name: "Itinerary",
      icon: "case",
      value: "all",
    },
    {
      name: "Transportation",
      icon: "bus",
      value: "move",
    },
    {
      name: "Accommodation",
      icon: "bed",
      value: "stay",
    },
    {
      name: "Activities",
      icon: "activity",
      value: "do",
    },
    {
      name: "Dining",
      icon: "dining",
      value: "eat",
    },
  ];

  const usedTypes = new Set();
  if (isPlan) {
    data?.forEach((day) => {
      let activity = day?.acts || day?.activities || day?.plan;
      activity?.forEach((act) => {
        let type = act.type;

        // Normalize certain types to "do"
        if (
          [
            "meetings",
            "team_outing",
            "work_activities",
            "other_sightseeing",
            "local_sightseeing",
            "sports_venue",
            "sport_merchandise_or_other",
            "sport_activities",
          ].includes(type)
        ) {
          type = "do";
        }

        usedTypes.add(type);
      });
    });
  }

  // Filter tagList to only show those types
  const filteredTagList = tagList?.filter(
    (tag) => tag.value === "all" || usedTypes.has(tag.value)
  );

  const [jsonVisible, setJsonVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [keyArray, setKeyArray] = useState([]);

  useEffect(() => {
    setJsonVisible(false);
    setActiveTab("all");
    setKeyArray([]);
    const keys = Object.keys(jsonStructure || {});
    if (keys?.length > 1) {
      let reorderedKeys = keys;
      if (
        category_slug !== "essentials" &&
        category_slug !== "accommodation" &&
        category_slug !== "food_dining" &&
        category_slug !== "transportation"
      ) {
        reorderedKeys = reorderedKeys.reverse();
      }
      const HIDDEN_KEYS = ["corporate_travel", "travel_overview", "trip_type"];
      const visibleKeys = reorderedKeys?.filter(
        (key) => !HIDDEN_KEYS.includes(key) && !key.startsWith("place_identity")
      );
      setKeyArray(visibleKeys);
      if (!isPlan || category_slug === "best_time_to_visit") {
        setActiveTab(visibleKeys[0]);
      }
    }
  }, [jsonStructure, renderKey, isPlan, category_slug]);

  const jsonStyle = {
    backgroundColor: "#2a2a2b",
    padding: "10px",
    borderRadius: "5px",
  };

  const handleShowJson = () => {
    setJsonVisible(!jsonVisible);
  };

  const filteredData =
    isPlan && activeTab !== "all"
      ? (keyArray?.includes(activeTab) ? jsonStructure[activeTab] : data)
        ?.map((day) => ({
          ...day,
          acts: (day?.acts || day?.activities || day?.plan)?.filter((act) => {
            const normalizedType = [
              "meetings",
              "team_outing",
              "work_activities",
              "other_sightseeing",
              "local_sightseeing",
              "sports_venue",
              "sport_merchandise_or_other",
              "sport_activities",
            ].includes(act.type)
              ? "do"
              : act.type;
            return normalizedType === activeTab;
          }),
        }))
        ?.filter((day) => day?.acts?.length > 0)
      : keyArray?.includes(activeTab)
        ? jsonStructure[activeTab]
        : data;

  let items = [];

  if (!keyArray.includes(activeTab)) {
    items = filteredData?.map((day, index) => ({
      key: String(index + 1),
      label: (
        <TitleContainer
          date={day?.dt || day?.date || day?.day}
          content={day?.act_ttl || day?.act_title || day?.activity_title}
          weather={day?.weather || ""}
        />
      ),
      children: <ListItems acts={day?.acts || day?.activities || day?.plan} />,
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #ccc",
        borderRadius: "10px",
      },
    }));
  } else {
    const PLACE_IDENTITY_STRING_KEYS = [
      "place_identity",
      "place_identity_notification_title",
      "place_identity_notification_body",
    ];

    const tabLabel = activeTab
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    let childContent;
    if (PLACE_IDENTITY_STRING_KEYS.includes(activeTab)) {
      const val = jsonStructure[activeTab];
      childContent = val ? (
        <div style={{ padding: "14px 18px" }}>
          <StyledItemContainer>
            <span>{tabLabel}</span>
            <div className="details" style={{ color: "#333", fontSize: "13px", marginTop: "6px" }}>
              {val}
            </div>
          </StyledItemContainer>
        </div>
      ) : (
        <Empty style={{ padding: "24px" }} />
      );
    } else {
      childContent = (
        <BestTimeListItems
          data={jsonStructure[activeTab]}
          activeTab={activeTab}
        />
      );
    }

    let newItem = {
      key: "1",
      label: <p className="mt-4">{tabLabel}</p>,
      children: childContent,
      style: {
        marginBottom: 18,
        boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
        border: "1px solid #ccc",
        borderRadius: "10px",
      },
    };
    items.unshift(newItem);
  }

  // if (
  //   category_slug === "best_time_to_visit" &&
  //   jsonStructure?.best_month_to_visit
  // ) {
  //   let newItem = {
  //     key: String(filteredData?.length + 1),
  //     label: <p className="mt-4">Best Time to Visit</p>,
  //     children: <BestTimeListItems data={jsonStructure?.best_month_to_visit} />,
  //     style: {
  //       marginBottom: 18,
  //       boxShadow: "-1px 1px 8px rgba(128, 128, 128, 0.2)",
  //       border: "1px solid #ccc",
  //       borderRadius: "10px",
  //     },
  //   };

  //   items.unshift(newItem);
  // }

  return (
    <div>
      <ScrollContainer>
        <StyledFlex vertical>
          <p className="title mb-3">
            {category_name} - {initialValues?.itineary_headline_text}
          </p>
          <Flex
            justify={
              keyArray?.length === 0 && !isPlan ? "flex-end" : "space-between"
            }
          >
            <Flex gap="5px" wrap>
              {isPlan && (
                <>
                  {category_slug === "best_time_to_visit" && (
                    <>
                      {keyArray?.map((act, index) => {
                        if (act === "plan" || act === "tips") return null;
                        return (
                          <StyledTag
                            key={index}
                            onClick={() => setActiveTab(act)}
                            className={activeTab === act ? "active" : ""}
                          >
                            <Icon
                              name={act}
                              style={{
                                height: "15px",
                                width: "15px",
                                marginRight: "5px",
                              }}
                            />
                            {
                              act === "package"
                                ? "Packing List"
                                : act === "documents"
                                  ? "Travel Documents"
                                  : act === "tips"
                                    ? "Travel Tips"
                                    : act === "tournament_booking_assistance"
                                      ? "Assistance"
                                      : act
                                        .replace(/_/g, " ") // Replace underscores with spaces
                                        .replace(/\b\w/g, (char) =>
                                          char.toUpperCase()
                                        ) // Capitalize first letter of each word
                            }
                          </StyledTag>
                        );
                      })}
                    </>
                  )}
                  {filteredTagList?.map((act, index) => (
                    <StyledTag
                      key={index}
                      onClick={() => setActiveTab(act?.value)}
                      className={activeTab === act?.value ? "active" : ""}
                    >
                      <Icon
                        name={act?.icon}
                        style={{
                          height: "15px",
                          width: "15px",
                          marginRight: "5px",
                        }}
                      />
                      {act?.name}
                    </StyledTag>
                  ))}
                </>
              )}
              {keyArray?.length > 0 && (
                <>
                  <p></p>
                  <>
                    {keyArray?.map((act, index) => {
                      console.log("act==", act)
                      if (act === "plan") return null;
                      if (category_slug !== "best_time_to_visit") {
                        return (
                          <StyledTag
                            key={index}
                            onClick={() => setActiveTab(act)}
                            className={activeTab === act ? "active" : ""}
                          >
                            <Icon
                              name={act}
                              style={{
                                height: "15px",
                                width: "15px",
                                marginRight: "5px",
                              }}
                            />
                            {
                              act === "package"
                                ? "Packing List"
                                : act === "documents"
                                  ? "Travel Documents"
                                  : act === "tips"
                                    ? "Travel Tips"
                                    : act === "stay"
                                      ? "Accommodation"
                                      : act === "restaurants"
                                        ? "Food and Dining"
                                        : act === "tournament_booking_assistance"
                                          ? "Assistance"
                                          : act
                                            .replace(/_/g, " ") // Replace underscores with spaces
                                            .replace(/\b\w/g, (char) =>
                                              char.toUpperCase()
                                            ) // Capitalize first letter of each word
                            }
                          </StyledTag>
                        );
                      }
                      if (
                        category_slug === "best_time_to_visit" &&
                        act === "tips"
                      ) {
                        return (
                          <StyledTag
                            key={index}
                            onClick={() => setActiveTab(act)}
                            className={activeTab === act ? "active" : ""}
                          >
                            <Icon
                              name={act}
                              style={{
                                height: "15px",
                                width: "15px",
                                marginRight: "5px",
                              }}
                            />
                            {
                              act === "package"
                                ? "Packing List"
                                : act === "documents"
                                  ? "Travel Documents"
                                  : act === "tips"
                                    ? "Travel Tips"
                                    : act === "tournament_booking_assistance"
                                      ? "Assistance"
                                      : act
                                        .replace(/_/g, " ") // Replace underscores with spaces
                                        .replace(/\b\w/g, (char) =>
                                          char.toUpperCase()
                                        ) // Capitalize first letter of each word
                            }
                          </StyledTag>
                        );
                      }
                      return null;
                    })}
                  </>
                </>
              )}
            </Flex>

            <StyledTag
              onClick={handleShowJson}
              className={jsonVisible ? "active_json" : ""}
            >
              {jsonVisible ? (
                <Icon
                  name="json_close"
                  style={{
                    height: "15px",
                    width: "15px",
                    marginRight: "5px",
                  }}
                />
              ) : (
                <Icon
                  name="json_open"
                  style={{
                    height: "15px",
                    width: "15px",
                    marginRight: "5px",
                  }}
                />
              )}
              {"JSON"}
            </StyledTag>
          </Flex>
        </StyledFlex>

        {jsonVisible ? (
          <>
            <JsonView
              src={jsonStructure}
              dark={true}
              theme="vscode"
              style={jsonStyle}
            />
          </>
        ) : (
          <>
            {isPlan ? (
              <>
                <Collapse
                  bordered={false}
                  defaultActiveKey={items?.map((item) => item.key)}
                  style={{ background: "#ffffff" }}
                  items={items}
                  expandIconPosition={"end"}
                />
              </>
            ) : (
              <>
                <CommonListItems
                  acts={
                    category_slug === "essentials"
                      ? essentialData
                      : filteredData
                  }
                  category_slug={category_slug}
                  activeCustomTab={activeTab}
                />
              </>
            )}
          </>
        )}
      </ScrollContainer>
    </div>
  );
}

export default ListView;
